"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentTextEditor = void 0;
exports.commentTextWithUserChanges = commentTextWithUserChanges;
var _react = _interopRequireWildcard(require("react"));
var _RedlineAuthorColorsContext = require("@common/components/remedy/RedlineAuthorColorsContext");
var _RedlinedText = require("@common/components/remedy/RedlinedText");
var _EditableRedlineParagraph = require("./EditableRedlineParagraph");
var _EditorActions = require("./EditorActions");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function commentTextWithUserChanges(text, textBeforeEdit, author) {
  if (textBeforeEdit === null || textBeforeEdit === text) return text;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlineAuthorColorsContext.InsideRedlinePreview, {
    "data-sentry-element": "InsideRedlinePreview",
    "data-sentry-component": "commentTextWithUserChanges",
    "data-sentry-source-file": "CommentTextEditor.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlinedText.RedlinedText, {
      textBefore: textBeforeEdit,
      text: text,
      author: author,
      "data-sentry-element": "RedlinedText",
      "data-sentry-source-file": "CommentTextEditor.tsx"
    })
  });
}
var CommentTextEditor = exports.CommentTextEditor = function CommentTextEditor(_ref) {
  var text = _ref.text,
    textBeforeEdit = _ref.textBeforeEdit,
    kindLabel = _ref.kindLabel,
    actionsSlot = _ref.actionsSlot,
    _onSave = _ref.onSave,
    onCancel = _ref.onCancel;
  var _useState = (0, _react.useState)(text),
    _useState2 = _slicedToArray(_useState, 2),
    draft = _useState2[0],
    setDraft = _useState2[1];
  var draftIsUnchanged = draft === text;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-3 cursor-default",
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    onKeyDown: function onKeyDown(event) {
      return event.stopPropagation();
    },
    "data-sentry-component": "CommentTextEditor",
    "data-sentry-source-file": "CommentTextEditor.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "py-1",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditableRedlineParagraph.EditableRedlineParagraph, {
        origin: {
          kind: "netNew",
          engineText: textBeforeEdit !== null && textBeforeEdit !== void 0 ? textBeforeEdit : text
        },
        text: draft,
        textBoxReads: text,
        proposalColor: (0, _EditableRedlineParagraph.proposalColorOf)(),
        ariaLabel: "Edit ".concat(kindLabel),
        allowsLineBreaks: true,
        onChange: setDraft,
        "data-sentry-element": "EditableRedlineParagraph",
        "data-sentry-source-file": "CommentTextEditor.tsx"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditorActions.EditorActions, {
      slot: actionsSlot,
      saveDisabled: draftIsUnchanged,
      onSave: function onSave() {
        return _onSave(draft);
      },
      onCancel: onCancel,
      "data-sentry-element": "EditorActions",
      "data-sentry-source-file": "CommentTextEditor.tsx"
    })]
  });
};